"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfilledValue = void 0;
/**
 * Check if a promise is fulfilled and return its value.
 * @param {T} defaultValue - The default value to return if the promise is not fulfilled. Defaults to `null`.
 * @param {string} errorMessage - The error message to log or throw if the promise is rejected.
 * @param {ChildLogger} logger - The logger to use for logging errors. If provided, it will log an error when the promise is rejected.
 * @param {PromiseSettledResult<T>} result - The result of the promise to check.
 * @param {boolean} shouldThrowOnRejected - If `true`, it will throw an error when the promise is rejected. Defaults to `false`.
 * @returns {T | null} - Returns the value of the fulfilled promise. If the promise is rejected, it returns the `defaultValue`.
 */
const getFulfilledValue = ({
  defaultValue,
  errorMessage,
  logger,
  result,
  shouldThrowOnRejected
}) => {
  if (result.status === 'rejected') {
    if (logger) {
      logger.error(new Error(errorMessage, {
        cause: result.reason
      }));
    }
    if (shouldThrowOnRejected) {
      throw new Error(errorMessage, {
        cause: result.reason
      });
    }
  }
  return result.status === 'fulfilled' ? result.value : defaultValue ?? null;
};
exports.getFulfilledValue = getFulfilledValue;
